import { useFirebase } from '../contexts/FirebaseContext';
import chatUseCase from '../../core/chat';
import { useStores } from '../../lib/store';
// #635 requires we send memberId in order to update unseenCount for dm message
const useSendMessage = (path, user, bailiwik = {}, to = false) => {
    const { firebase } = useFirebase();
    const { bailiwikStore } = useStores();

    const sendMessage = (type, content, options = {}) => {
        const bailiwikId = typeof bailiwik === 'string' ? bailiwik : bailiwik._id;
        const bailiwikName = bailiwik?.name || bailiwikStore?.current?.name;
        options.bailiwik = {
          _id: bailiwikId,
          name: bailiwikName
        };
        if (to) {
          options.to = to;
        }
        const chatRef = firebase.database().ref(path);

        return chatUseCase.sendMessage(chatRef, type, content, user, options);
    };

    return sendMessage;
};

export default useSendMessage;
